<template>
  <div>
    <v-row class="pt-0 pb-0 mt-n5  ">
      <v-col cols="8">
        <label class="input-text-size">Town : </label>
      </v-col >
      <v-col cols="4">
        <label class="input-text-size">{{ editedItem.town }}</label>
      </v-col>
    </v-row >
    <v-row class="pt-0 pb-0 mt-n5  ">
      <v-col cols="8">
        <label class="input-text-size">Direction : </label>
      </v-col>
      <v-col cols="4">
        <label class="input-text-size">{{ editedItem.direction }}</label>
      </v-col>
    </v-row>
    <v-row class="pt-0 pb-0 mt-n5  ">
      <v-col cols="8">
        <label class="input-text-size">Street Name : </label>
      </v-col>
      <v-col cols="4">
        <label class="input-text-size">{{ editedItem.streetName }}</label>
      </v-col>

    </v-row>
    <v-row class="pt-0 pb-0 mt-n5  ">
      <v-col cols="8">
        <label class="input-text-size">Type : </label>
      </v-col>
      <v-col cols="4">
        <label class="input-text-size">{{ editedItem.streetType }}</label>
      </v-col>

    </v-row>
    <v-row class="pt-0 pb-0 mt-n5  ">
      <v-col cols="8">
        <label class="input-text-size">Count : </label>
      </v-col>
      <v-col cols="4">
        <label class="input-text-size">{{ editedItem.count }}</label>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
} from 'vuex';

export default {
  name: 'taxstreetsDialog',
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxStreetsTable',
    },
  },
  components: {
  },
  data() {
    return {
      fromDate: '07/01/2023',
      checkbox: true,
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
  },
};
</script>
